import * as types from 'appRedux/actions/calendar/calendarModuleActionType';
import type {
  CalendarDefinition,
  CalendarEvent,
  CalendarLookupEvent,
  CalendarPaging,
  CalendarProcess,
  CalendarSource,
} from '@/types/calendarModule';

interface CalendarModuleState {
  moduleAvailable: boolean;
  calendars: CalendarDefinition[];
  events: CalendarEvent[];
  eventPaging: CalendarPaging | null;
  sources: CalendarSource[];
  lookupEvents: CalendarLookupEvent[];
  loading: {
    calendars: boolean;
    events: boolean;
    sources: boolean;
    lookup: boolean;
    mutation: boolean;
  };
  process: CalendarProcess;
}

const emptyProcess: CalendarProcess = {
  action: '',
  status: false,
  message: '',
  sequence: 0,
};

const initialState: CalendarModuleState = {
  moduleAvailable: true,
  calendars: [],
  events: [],
  eventPaging: null,
  sources: [],
  lookupEvents: [],
  loading: {
    calendars: false,
    events: false,
    sources: false,
    lookup: false,
    mutation: false,
  },
  process: emptyProcess,
};

export default (state = initialState, action: any): CalendarModuleState => {
  switch (action.type) {
    case types.CALENDAR_MODULE_LIST_REQUEST:
      return { ...state, loading: { ...state.loading, calendars: true } };
    case types.CALENDAR_MODULE_LIST_SUCCESS:
      return {
        ...state,
        moduleAvailable: true,
        calendars: action.payload,
        loading: { ...state.loading, calendars: false },
      };
    case types.CALENDAR_MODULE_UNAVAILABLE:
      return {
        ...state,
        moduleAvailable: false,
        loading: {
          calendars: false,
          events: false,
          sources: false,
          lookup: false,
          mutation: false,
        },
      };
    case types.CALENDAR_MODULE_LIST_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, calendars: false },
        process: { ...action.payload, sequence: state.process.sequence + 1 },
      };
    case types.CALENDAR_EVENT_LIST_REQUEST:
      return { ...state, loading: { ...state.loading, events: true } };
    case types.CALENDAR_EVENT_LIST_SUCCESS:
      return {
        ...state,
        events: action.payload.items,
        eventPaging: action.payload.paging,
        loading: { ...state.loading, events: false },
      };
    case types.CALENDAR_EVENT_LIST_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, events: false },
        process: { ...action.payload, sequence: state.process.sequence + 1 },
      };
    case types.CALENDAR_SOURCE_LIST_REQUEST:
      return { ...state, sources: [], loading: { ...state.loading, sources: true } };
    case types.CALENDAR_SOURCE_LIST_SUCCESS:
      return {
        ...state,
        sources: action.payload,
        loading: { ...state.loading, sources: false },
      };
    case types.CALENDAR_SOURCE_LIST_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, sources: false },
        process: { ...action.payload, sequence: state.process.sequence + 1 },
      };
    case types.CALENDAR_LOOKUP_REQUEST:
      return { ...state, loading: { ...state.loading, lookup: true } };
    case types.CALENDAR_LOOKUP_SUCCESS:
      return {
        ...state,
        lookupEvents: action.payload,
        loading: { ...state.loading, lookup: false },
      };
    case types.CALENDAR_LOOKUP_FAILURE:
      return { ...state, loading: { ...state.loading, lookup: false }, lookupEvents: [] };
    case types.CALENDAR_MUTATION_REQUEST:
      return { ...state, loading: { ...state.loading, mutation: true } };
    case types.CALENDAR_MUTATION_SUCCESS:
    case types.CALENDAR_MUTATION_FAILURE:
      return {
        ...state,
        loading: { ...state.loading, mutation: false },
        process: {
          ...action.payload,
          sequence: state.process.sequence + 1,
        },
      };
    case types.CALENDAR_MODULE_PROCESS_RESET:
      return { ...state, process: { ...emptyProcess, sequence: state.process.sequence } };
    default:
      return state;
  }
};
